export const API_ROOT =
  process.env.REACT_APP_SERVER_URL || 'http://localhost:5000';

export const S3_BUCKET = 'exocortex-crateandbarrel';
export const S3_FOLDER = 'AR_ASSETS/';
